var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({ref:"type",attrs:{"loading":_vm.loading,"items":_vm.items,"value":_vm.internalValue,"item-text":"title","item-value":"value","rules":_vm.requiredRules},on:{"input":_vm.updateValue}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }